import React, { useEffect } from "react";
import { Layout } from "@components/layout/Layout";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";


export const Terms_Conditions = () => {
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > window.innerHeight / 3) {
        document.body.classList.add("show-scroll-btn");
      } else {
        document.body.classList.remove("show-scroll-btn");
      }
    };
    const handleClick = () => {
      document.body.classList.toggle("hidden");
      document.documentElement.classList.toggle("hidden");
    };

    const checkMenu = document.getElementById("check-menu");
    if (checkMenu) {
      checkMenu.addEventListener("click", handleClick);
    }

    window.addEventListener("scroll", handleScroll);

    return () => {
      if (checkMenu) {
        checkMenu.removeEventListener("click", handleClick);
      }
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    document.body.classList.add("main-page");
    return () => {
      document.body.classList?.remove("main-page");
    };
  }, []);

  return (
    <Layout>
      <div className="basic-main">
        <div className="container">
        <h1>Terms and Conditions</h1>
          <div className="section">  
  <p>Please read these Terms carefully before using the Cronika platform.</p>
  <p>By accessing or using Cronika's website, mobile application, or any of our services (collectively referred to as the "Platform"), you confirm that you are of legal age and agree to be bound by the following Terms and Conditions. If you do not agree with these Terms, please do not use the Platform.</p>

  <h3>1. Definitions</h3>
  
    <p><strong>1.1</strong> "Platform" refers to all Cronika digital properties, including our website and mobile applications.</p>
    <p><strong>1.2</strong> "User," "you," or "your" refers to any individual or entity using or accessing the Platform.</p>
    <p><strong>1.3</strong> "Company," "we," "our," or "Cronika" refers to the owners and operators of the Cronika platform.</p>
    <p><strong>1.4</strong> "Services" refers to all functionality provided via the Platform, including trading tools, account management, market data, and customer support.</p>
    <p><strong>1.5</strong> "Order" refers to any trade, transaction, or instruction initiated by the user via the Platform.</p>
    <p><strong>1.6</strong> "Account" refers to the personalized user profile registered with Cronika, used for accessing Services.</p>
    <p><strong>1.7</strong> "Balance" refers to the digital or fiat funds held in a user's account.</p>
    <p><strong>1.8</strong> "Credits" refers to promotional or rewarded units issued by Cronika, usable only within the Platform.</p>
  

  <h3>2. Account Registration and Use</h3>
  
    <p><strong>2.1</strong> To access full Services, users must create an account and provide accurate, current information.</p>
    <p><strong>2.2</strong> Users are responsible for safeguarding their account credentials. All activities under a user’s account are the sole responsibility of that user.</p>
    <p><strong>2.3</strong> Multiple accounts per user are not permitted unless explicitly authorized by Cronika. Duplicate accounts may be suspended.</p>
    <p><strong>2.4</strong> You agree to notify us immediately of any unauthorized use or breach of security.</p>
    <p><strong>2.5</strong> The following users are strictly prohibited from registering or maintaining an Account with Cronika: 
                           <p>(a) Legal entities, trusts, or similar arrangements acting as corporate clients; </p>  
                           <p>(b) Individuals depositing or withdrawing funds on behalf of third parties or using third-party payment methods; </p>  
                           <p>(c) Individuals attempting to fund their accounts via unsupported means, including but not limited to cash deposits;</p>   
                           <p>(d) Users accessing the Platform for any purpose other than lawful trading activities as permitted by Cronika;  </p>                                      
                           <p>(e) U.S. reportable persons and residents of jurisdictions not supported by Cronika, including but not limited to: North Korea, Palestine, the Russian Federation, the United States, Vatican City State, or territories under their jurisdiction or control.</p>
                           <p>Cronika reserves the right to suspend or terminate any Account found in breach of this section.</p></p>


  <h3>3. Payments and Fees</h3>
  
    <p><strong>3.1</strong> Certain features of the Platform may require payment of fees, which are disclosed transparently during each transaction.</p>
    <p><strong>3.2</strong> Payments can be made using supported methods, including debit/credit cards, cryptocurrencies, or other options available at the time of use.</p>
    <p><strong>3.3</strong> Cronika may offer discount programs, loyalty rewards, and promotional credits at its sole discretion.</p>
    <p><strong>3.4</strong> Users are responsible for complying with applicable tax regulations in their jurisdiction.</p>
  

  <h3>4. Credits and Loyalty Programs</h3>
  
    <p><strong>4.1</strong> Promotional credits issued by Cronika can be used only within the Platform and are non-transferable and non-refundable.</p>
    <p><strong>4.2</strong> Certain actions or milestones may earn users Credits, which expire 6 months after issuance unless otherwise stated.</p>
    <p><strong>4.3</strong> Cronika reserves the right to alter, suspend, or terminate loyalty programs at any time.</p>
  

  <h3>5. Trading Activity and Orders</h3>
  
    <p><strong>5.1</strong> Users initiate trades at their own discretion. Cronika does not provide investment advice or guarantee outcomes.</p>
    <p><strong>5.2</strong> It is your responsibility to ensure the accuracy of any Order you place.</p>
    <p><strong>5.3</strong> Orders, once executed, cannot be reversed unless explicitly allowed by the trading logic or technical mechanism.</p>
    <p><strong>5.4</strong> Cronika reserves the right to halt, modify, or cancel Orders in case of system errors, suspected fraud, or regulatory intervention.</p>
  

  <h3>6. Use of Platform</h3>
  
    <p><strong>6.1</strong> You agree to use the Platform solely for lawful purposes and in compliance with all applicable regulations.</p>
    <p><strong>6.2</strong> You must not attempt to exploit, copy, disrupt, or interfere with the Platform or other users.</p>
    <p><strong>6.3</strong> Unauthorized data scraping, reverse-engineering, or automation (e.g., bots) is strictly prohibited.</p>
  

  <h3>7. Account Suspension or Termination</h3>
  
    <p><strong>7.1</strong> Cronika may suspend or terminate your access for violating these Terms or for any reason deemed necessary to protect the Platform or its users.</p>
    <p><strong>7.2</strong> In cases of termination, users may be entitled to withdraw remaining balances, subject to regulatory and security checks.</p>
  

  <h3>8. Intellectual Property</h3>
  
    <p><strong>8.1</strong> All Platform content — including design, code, trademarks, and data — remains the intellectual property of Cronika or its licensors.</p>
    <p><strong>8.2</strong> You are granted a limited, non-exclusive, revocable license to use the Platform for personal or internal business purposes.</p>
    <p><strong>8.3</strong> Any reproduction, distribution, or derivative use of Platform content without written consent is prohibited.</p>
  

  <h3>9. Limitation of Liability</h3>
  
    <p><strong>9.1</strong> Cronika is not liable for losses resulting from your use of the Platform, including trading losses, service interruptions, or data issues.</p>
    <p><strong>9.2</strong> Services are provided on an "as is" basis without warranties of any kind.</p>
    <p><strong>9.3</strong> Users are advised to conduct their own research and consult financial professionals before making trading decisions.</p>
  

  <h3>10. Privacy and Communication</h3>
  
    <p><strong>10.1</strong> Your use of the Platform is subject to our Privacy Policy, which outlines how your data is collected, used, and stored.</p>
    <p><strong>10.2</strong> By using Cronika, you agree to receive service updates, policy notices, and promotional offers via email or in-app communication. You may opt out where applicable.</p>
  

  <h3>11. Changes to Terms</h3>
  
    <p><strong>11.1</strong> Cronika may revise these Terms at any time. Continued use of the Platform after changes implies acceptance of the updated Terms.</p>
    <p><strong>11.2</strong> Users are encouraged to review these Terms periodically.</p>
  

  <p>If you have any questions or concerns about these Terms and Conditions, please contact us at: <a href="mailto:support@cronika.com">support@cronika.com</a></p>

          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Terms_Conditions;
